import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { CodCaenAutorizat } from "@/types/identificareFirma";

type CaenPrincipalSelectorProps = {
  coduri: CodCaenAutorizat[];
  onConfirm: (cod: string) => void;
  isSaving?: boolean;
};

function CaenPrincipalSelector({
  coduri,
  onConfirm,
  isSaving = false,
}: CaenPrincipalSelectorProps) {
  const [cod, setCod] = useState("");

  return (
    <div className="rounded-lg border border-ds-amber-500/30 bg-ds-amber-100 p-4 space-y-3">
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0 text-ds-amber-500" />
        <div className="space-y-1">
          <p className="text-sm font-medium text-navy-800">
            Codul CAEN principal nu a putut fi preluat
          </p>
          <p className="text-xs text-navy-800/80">
            Alegeți-l dintre codurile autorizate ale firmei sau introduceți-l
            manual. Serviciile identificate nu depind de el.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-2 md:flex-row md:items-end">
        <div className="flex-1">
          <Label className="text-xs">Cod CAEN principal</Label>
          {coduri.length > 0 ? (
            <Select value={cod} onValueChange={setCod}>
              <SelectTrigger className="text-xs md:text-sm">
                <SelectValue placeholder="Selectați codul" />
              </SelectTrigger>
              <SelectContent>
                {coduri.map((element) => (
                  <SelectItem
                    key={`${element.ver}-${element.cod}`}
                    value={element.cod}
                  >
                    {element.cod} (Rev. {element.ver})
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : (
            <Input
              value={cod}
              onChange={(event) => setCod(event.target.value)}
              placeholder="ex: 6311"
              className="text-xs md:text-sm"
            />
          )}
        </div>
        <Button
          type="button"
          size="sm"
          disabled={!cod.trim() || isSaving}
          onClick={() => onConfirm(cod.trim())}
        >
          {isSaving ? "Se salvează..." : "Salvează"}
        </Button>
      </div>
    </div>
  );
}

export default CaenPrincipalSelector;
